import { GLHF } from '../../../../../constants';
import { FlexLayout } from '../../../../../components';
import { Format } from '../../../../../utils/string';
import { ConstructionSales } from '../ConstructionSales';
import { MainModel } from '../models/Main.model';

/**
 * 화면 > 상단 그리드 레이아웃
 * @window w_tb_e471w_04
 * @category 공사수주매출통계
 */
export const GridHeader: GLHF<MainModel, ConstructionSales> = (scope) => ([
  {
    id: 'spjangnm',
    text: '사업장명',
    width: 12,
    trail: () => (
      <FlexLayout
        justify="center"
        align="center"
      >
        합 계
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.spjangnm}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt',
    text: '수주금액',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="left"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope?.state.contamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt12',
    text: '수주(수리공사)',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="left"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope?.state.contamt12_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt12)}
      </FlexLayout>
    ),
  },
  {
    id: 'contamt13',
    text: '수주(부품교체)',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope?.state.contamt13_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.contamt13)}
      </FlexLayout>
    ),
  },
  {
    id: 'contamtmu',
    text: '수주(무상)',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#633A00' }}
      >
        {scope?.state.contamtmu_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: '#633A00' }}
      >
        {Format.number(x.contamtmu)}
      </FlexLayout>
    ),
  },
  {
    id: 'notmisamt',
    text: '미매출',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope?.state.notmisamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.notmisamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'misamt',
    text: '공사매출',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope?.state.misamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.misamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'rcvamt',
    text: '공사입금',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {scope?.state.rcvamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(x.rcvamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'iamt',
    text: '공사미수금',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope?.state.iamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.iamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'jamt',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          잔액
        </FlexLayout>

        <FlexLayout>
          (수주-입금)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope?.state.jamt_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.jamt)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty',
    text: '건수',
    width: 4,
    trail: (_) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.qty_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Format.number(x.qty)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty12',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          건수
        </FlexLayout>

        <FlexLayout>
          (공사)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 4,
    trail: (_) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.qty12_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Format.number(x.qty12)}
      </FlexLayout>
    ),
  },
  {
    id: 'qty13',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          건수
        </FlexLayout>

        <FlexLayout>
          (부품)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 4,
    trail: (_) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.qty13_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {Format.number(x.qty13)}
      </FlexLayout>
    ),
  },
  {
    id: 'qtymu',
    text: (
      <FlexLayout isVertical={true}>
        <FlexLayout>
          건수
        </FlexLayout>

        <FlexLayout>
          (무상)
        </FlexLayout>
      </FlexLayout>
    ),
    width: 4,
    trail: (_) => (
      <FlexLayout
        justify="center"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {scope?.state.qtymu_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
        style={{ color: '#7F7A2C' }}
      >
        {Format.number(x.qtymu)}
      </FlexLayout>
    ),
  },
  {
    id: 'misamt2',
    text: '메출',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {scope?.state.misamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
      >
        {Format.number(x.misamt2)}
      </FlexLayout>
    ),
  },
  {
    id: 'rcvamt2',
    text: '입금',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {scope?.state.rcvamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-blue)' }}
      >
        {Format.number(x.rcvamt2)}
      </FlexLayout>
    ),
  },
  {
    id: 'iamt2',
    text: '미수금',
    width: 6,
    trail: (_) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {scope?.state.iamt2_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="right"
        align="center"
        style={{ color: 'var(--color-red)' }}
      >
        {Format.number(x.iamt2)}
      </FlexLayout>
    ),
  },
]);
